import  axiosInstance  from "./config/axiosConfigs";
import { getToken } from "../cookie/authCookie";



export const NotificationAPI = {

   postSendEmail: async function (emailInfo) {
    const response = await axiosInstance.request({
      url: `/notification/email/send`,
      method: "POST",
      withCredentials: true,
      // timeout: 4000,
      data: emailInfo,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  getMessageByUser: async function (chatId,userId,beforeCreatedAt,beforeMessageId,limit) {
    let url;
      if(beforeCreatedAt && beforeMessageId){
      url = `/message/${chatId}/user/${userId}?beforeCreatedAt=${beforeCreatedAt}&beforeMessageId=${beforeMessageId}&limit=${limit}`;
    }else{
      url = `/message/${chatId}/user/${userId}?limit=${limit}`;
    }
    const response = await axiosInstance.request({
      url: url,
      method: "GET",
      withCredentials: true,
      timeout: 20000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  getLastMessageByUser: async function (userId,clubId) {
    const response = await axiosInstance.request({
      url: `/message/last-msg/${userId}/club/${clubId}`,
      method: "GET",
      withCredentials: true,
      timeout: 20000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  getTotalUnreadMessage: async function (clubId,userId) {
    const response = await axiosInstance.request({
      url: `/message/unread-msg/user/${userId}/club/${clubId}`,
      method: "GET",
      withCredentials: true,
      timeout: 200000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
   getAllUnreadMessageId: async function (data) {
    const response = await axiosInstance.request({
      url: `/message/unread-msg`,
      method: "POST",
      withCredentials: true,
      timeout: 200000,
      data:data,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  getUserChatStatus: async function (userId) {
    const response = await axiosInstance.request({
      url: `/message/chat/status/user/${userId}`,
      method: "GET",
      withCredentials: true,
      timeout: 20000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  getFewChatGroupMemberNames: async function (chatId) {
    const response = await axiosInstance.request({
      url: `/chat-group/member/short/chat/${chatId}`,
      method: "GET",
      withCredentials: true,
      timeout: 20000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data
  },
  postCreateChatGroup: async function (groupData, image) {
    let formData = new FormData();
    formData.append("image", image);
    formData.append("groupData", JSON.stringify(groupData));
    const response = await axiosInstance.request({
      url: `/chat-group/create`,
      method: "POST",
      data: formData,
      // timeout: 2000,
      headers: {
        Authorization: `Bearer ${getToken()}`
      },
    });
    return response.data
  },
};